/**
 * Terms of Service Translations Module (Spanish)
 * 
 * @module terms
 * @language es
 */

export const terms = {
  pageTitle: "Términos de Servicio",
  heroSubtitle: "Por favor, lea estos términos cuidadosamente antes de usar nuestra plataforma.",
  lastUpdated: "Última Actualización: Enero de 2026",
  effectiveDate: "Vigencia: 1 de Enero de 2026",

  intro: {
    title: "Introducción",
    welcome: "Bienvenido al Observatorio de Futuros Juveniles de los Consejos de Desarrollo JCI (la \"Plataforma\"). Estos Términos de Servicio (\"Términos\") rigen su acceso y uso de nuestra plataforma.",
    acceptance: "Al acceder o usar esta Plataforma, usted acepta quedar vinculado por estos Términos. Si no está de acuerdo con estos Términos, por favor no use la Plataforma.",
    modifications: "Podemos modificar estos Términos en cualquier momento. El uso continuado de la Plataforma después de los cambios constituye la aceptación de los Términos modificados.",
  },

  eligibility: {
    title: "Elegibilidad",
    age: "Debe tener al menos 18 años de edad para usar esta Plataforma. Al usar la Plataforma, usted declara y garantiza que cumple con este requisito de edad.",
    membership: "Aunque la Plataforma está disponible para el público en general, ciertas funciones pueden estar restringidas a miembros de JCI o usuarios registrados.",
    accuracy: "Usted acepta proporcionar información precisa, actual y completa durante el registro y mantener y actualizar dicha información.",
  },

  account: {
    title: "Responsabilidades de la Cuenta",
    security: "Usted es responsable de mantener la confidencialidad de las credenciales de su cuenta y de todas las actividades que ocurran bajo su cuenta.",
    notification: "Debe notificarnos inmediatamente sobre cualquier uso no autorizado de su cuenta o cualquier otra violación de seguridad.",
    prohibition: "No puede compartir las credenciales de su cuenta con otros ni permitir que otros accedan a la Plataforma usando su cuenta.",
  },

  acceptableUse: {
    title: "Uso Aceptable",
    description: "Usted acepta usar la Plataforma solo para fines lícitos y de acuerdo con estos Términos.",
    prohibited: "Usted no puede:",
    item1: "Usar la Plataforma para cualquier propósito ilegal o no autorizado",
    item2: "Intentar obtener acceso no autorizado a sistemas, redes o datos",
    item3: "Interferir o interrumpir la Plataforma o servidores o redes conectados a ella",
    item4: "Usar cualquier medio automatizado para acceder a la Plataforma o recopilar datos",
    item5: "Transmitir virus, malware u otro código dañino",
    item6: "Suplantar a cualquier persona o entidad o tergiversar su afiliación",
    item7: "Recopilar información personal de otros usuarios sin consentimiento",
    item8: "Usar la Plataforma para spam, phishing o actividades fraudulentas",
  },

  intellectualProperty: {
    title: "Propiedad Intelectual",
    jciTrademarks: "JCI, Junior Chamber International, el logotipo de JCI y todas las marcas registradas, marcas de servicio y logotipos relacionados son propiedad de Junior Chamber International. No puede usar estas marcas sin permiso previo por escrito.",
    dataLicense: "Los datos, visualizaciones y contenido en esta Plataforma se proporcionan bajo la Licencia Creative Commons Atribución-NoComercial-CompartirIgual 4.0 Internacional (CC BY-NC-SA 4.0), salvo indicación contraria.",
    restrictions: "No puede usar nuestra propiedad intelectual con fines comerciales sin autorización explícita por escrito.",
    platformCredits: "La Plataforma es desarrollada y mantenida por DashCity en asociación con los Consejos de Desarrollo JCI.",
  },

  dataPrivacy: {
    title: "Datos y Privacidad",
    reference: "Su uso de la Plataforma también se rige por nuestra Política de Privacidad, que describe cómo recopilamos, usamos y protegemos su información personal.",
    link: "Por favor, revise nuestra Política de Privacidad para comprender nuestras prácticas de datos.",
    gdpr: "Estamos comprometidos con el cumplimiento del RGPD y respetamos sus derechos de protección de datos.",
  },

  thirdParty: {
    title: "Servicios de Terceros",
    description: "La Plataforma puede contener enlaces a sitios web o servicios de terceros que no son de nuestra propiedad ni están controlados por nosotros.",
    disclaimer: "No tenemos control sobre, y no asumimos responsabilidad por el contenido, las políticas de privacidad o las prácticas de cualquier sitio web o servicio de terceros.",
    acknowledgment: "Usted reconoce y acepta que no seremos responsables por ningún daño o pérdida causado por o en conexión con su uso de cualquier contenido, bienes o servicios de terceros.",
  },

  disclaimers: {
    title: "Descargos de Responsabilidad",
    asIs: "LA PLATAFORMA SE PROPORCIONA \"TAL CUAL\" Y \"SEGÚN DISPONIBILIDAD\" SIN GARANTÍAS DE NINGÚN TIPO, YA SEAN EXPRESAS O IMPLÍCITAS.",
    noWarranty: "No garantizamos que la Plataforma sea ininterrumpida, segura o libre de errores, o que cualquier defecto será corregido.",
    accuracy: "Aunque nos esforzamos por proporcionar datos e información precisos, no hacemos garantías con respecto a la exactitud, integridad o confiabilidad de cualquier contenido en la Plataforma.",
    research: "Los datos e insights proporcionados son solo para fines informativos y no deben ser la única base para la toma de decisiones.",
  },

  responsibilities: {
    title: "Sus Responsabilidades",
    description: "Usted es responsable de su uso de la Plataforma y acepta usarla de acuerdo con estos Términos y todas las leyes aplicables. Usted entiende que cualquier uso indebido de la Plataforma puede resultar en la terminación de su acceso.",
  },

  governingLaw: {
    title: "Ley Aplicable",
    jurisdiction: "Estos Términos se regirán e interpretarán de acuerdo con los principios aplicables del derecho internacional y las leyes de la jurisdicción donde se realizan las operaciones principales de la Plataforma.",
    disputes: "Cualquier disputa que surja de estos Términos o de su uso de la Plataforma se resolverá mediante negociación de buena fe. Si la negociación falla, las disputas pueden someterse a arbitraje vinculante.",
    severability: "Si alguna disposición de estos Términos se considera inaplicable, las disposiciones restantes continuarán en pleno vigor y efecto.",
  },

  termination: {
    title: "Terminación",
    byUs: "Podemos terminar o suspender su acceso a la Plataforma en cualquier momento, con o sin causa, y con o sin previo aviso.",
    byYou: "Puede dejar de usar la Plataforma en cualquier momento. Si tiene una cuenta, puede eliminarla a través de la página de Configuración.",
    survival: "Las disposiciones que por su naturaleza deban sobrevivir a la terminación sobrevivirán, incluyendo las disposiciones de propiedad intelectual, descargos de responsabilidad y limitaciones de responsabilidad.",
  },

  contact: {
    title: "Contáctenos",
    description: "Si tiene alguna pregunta sobre estos Términos de Servicio, contáctenos:",
    email: "Correo electrónico: tmariano@jci.cc",
    response: "Nuestro objetivo es responder a todas las consultas dentro de 5 días hábiles.",
  },
} as const;
